import requestExodus from 'config/requestExodus';

const exodusInstance = {
  defaultInstance: requestExodus(),
  noAlert: requestExodus(false),
};

export default exodusInstance;
